(function ($) {

    'use strict';

    /*-------------------------------------------
        Sticky Header
    --------------------------------------------- */

    let win = $(window);
    let sticky_id = $(".header-area");
    win.on('scroll', function () {
        let scroll = win.scrollTop();
        if (scroll < 245) {
            sticky_id.removeClass("sticky-header");
        } else {
            sticky_id.addClass("sticky-header");
        }
    });

    /*------------------------------------
        Data-Background
    --------------------------------------*/
    $("[data-background]").each(function () {
        $(this).css("background-image", "url(" + $(this).attr("data-background") + ")")
    });

    $("[data-bg-color]").each(function () {
        $(this).css("background", $(this).attr("data-bg-color"))
    });


    if (jQuery(".track-slider-active .swiper").length > 0) {
        let trackSlider = new Swiper('.track-slider-active .swiper', {
            // Optional parameters
            slidesPerView: 1,
            slidesPerColumn: 1,
            paginationClickable: true,
            loop: false,
            spaceBetween: 30,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
            },

            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },

            autoplay: {
                delay: 30000,
            },

            // If we need pagination
            pagination: {
                el: '.track-pagination',
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.track-button-next',
                prevEl: '.track-button-prev',
            },

            a11y: false,

        });
    }

    if (jQuery(".testimonial-slider-active .swiper").length > 0) {
        let testimonialSlider1 = new Swiper('.testimonial-slider-active .swiper', {
            // Optional parameters
            slidesPerView: 1.2,
            slidesPerColumn: 1,
            paginationClickable: true,
            loop: true,
            spaceBetween: 20,
            autoHeight: true,

          

            // If we need pagination
            pagination: {
                el: '.testimonial-pagination',
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.testimonial-button-next',
                prevEl: '.testimonial-button-prev',
            },

            a11y: false,
        });
    }

    if (jQuery(".feature-slider-active .swiper").length > 0) {
        let featureSlider1 = new Swiper('.feature-slider-active .swiper', {
            // Optional parameters
            slidesPerView: 1.2,
            slidesPerColumn: 1,
            paginationClickable: true,
            loop: true,
            spaceBetween: 20,
            autoHeight: true,

            autoplay: {
                delay: 3000,
            },

            // If we need pagination
            pagination: {
                el: '.feature-pagination',
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.feature-button-next',
                prevEl: '.feature-button-prev',
            },

            a11y: false,
        });
    }

    if (jQuery(".video-slider-active .swiper").length > 0) {
        let videoSlider1 = new Swiper('.video-slider-active .swiper', {
            // Optional parameters
            slidesPerView: 1.2,
            slidesPerColumn: 1,
            paginationClickable: true,
            loop: true,
            spaceBetween: 20,
            autoHeight: true,

            autoplay: {
                delay: 3000,
            },

            // If we need pagination
      

            // Navigation arrows
            navigation: {
                nextEl: '.feature-button-next',
                prevEl: '.feature-button-prev',
            },

            a11y: false,
        });
    }


    Fancybox.bind('[data-fancybox]', {
        Html: {
            youtube: {
                controls: 0,
                rel: 0,
                fs: 0
            }
        }
    });

})(jQuery);
const video = document.querySelector('video');
const playPauseBtn = document.querySelector('.play-pause-btn');

playPauseBtn.addEventListener('click', () => {
    if (video.paused) {
        video.play();
        playPauseBtn.classList.add('playing');
    } else {
        video.pause();
        playPauseBtn.classList.remove('playing');
    }
});
document.addEventListener('DOMContentLoaded', function () {
    const playPauseButtons = document.querySelectorAll('.play-pause-btn');

    playPauseButtons.forEach(button => {
        button.addEventListener('click', function () {
            const video = this.closest('.result-video').querySelector('.video-item');

            if (video.paused) {
                video.play();
                this.classList.remove('paused');
            } else {
                video.pause();
                this.classList.add('paused');
            }
        });
    });
});


  document.addEventListener("DOMContentLoaded", function() {
        var desktopVideo = document.getElementById("desktop-video");
        var mobileVideo = document.getElementById("mobile-video");

        function playVideoWhenVisible(video) {
            if (!video) return;

            var observer = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        video.play();
                        observer.unobserve(entry.target); // Stop observing once the video is played
                    }
                });
            }, { threshold: 0.5 }); // Trigger when 50% of the video is visible

            observer.observe(video);
        }

        if (desktopVideo) {
            playVideoWhenVisible(desktopVideo);
        }
        if (mobileVideo) {
            playVideoWhenVisible(mobileVideo);
        }
    });

 var swiper = new Swiper('.video-swiper', {
    slidesPerView: 1.5,
    spaceBetween: 20,
   
    breakpoints: {
      768: { // ברזולוציה מעל 768px (טאבלטים ומעלה)
        slidesPerView: 2,

      },
      1024: { // ברזולוציה מעל 1024px (דסקטופ)
        slidesPerView: 4,
      }
    },
  
  });


